import DogMemberRelation from './DogMemberRelation';
import MemberContractHistory from './MemberContractHistory';
import MemberContractState from './MemberContractState';
import ParameterValue from './ParameterValue';

export default class MemberShortProfile {
    fullNameWithTitle() {
        let fullName = this.fullName;

        if (this.academicTitle) {
            fullName = this.academicTitle.value + ' ' + fullName;
        }

        return fullName;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let memberShortProfile = new MemberShortProfile();
        memberShortProfile.id = data.id;

        memberShortProfile.academicTitle = null;
        if (data.academicTitle && data.academicTitle.data) {
            memberShortProfile.academicTitle = ParameterValue.fromData(data.academicTitle.data);
        }

        memberShortProfile.fullName = data.fullName;
        memberShortProfile.firstName = data.firstName;
        memberShortProfile.hasAvatar = data.hasAvatar;
        memberShortProfile.avatarFileName = data.avatarFileName;
        memberShortProfile.gender = data.gender;
        memberShortProfile.street = data.street;
        memberShortProfile.careOf = data.careOf;
        memberShortProfile.zip = data.zip;
        memberShortProfile.city = data.city;
        memberShortProfile.contractState = new MemberContractState(data.contractState.status, data.contractState.contractType);
        memberShortProfile.membershipNumber = data.membershipNumber;
        memberShortProfile.dateOfBirth = data.dateOfBirth;
        memberShortProfile.departments = data.departments;
        memberShortProfile.teams = data.teams;
        memberShortProfile.phone = data.phone;
        memberShortProfile.phoneMobile = data.phoneMobile;
        memberShortProfile.email = data.email;
        memberShortProfile.contractHistory = MemberContractHistory.fromData(data.contracts.data);
        memberShortProfile.comment = data.comment;
        memberShortProfile.bookkeepingComment = data.bookkeepingComment;
        memberShortProfile.isDunningActive = data.isDunningActive;
        memberShortProfile.accountsReceivableNumber = data.accountsReceivableNumber;

        memberShortProfile.relations = this.relationsFromData(data.relations);

        memberShortProfile.company = data.company;
        memberShortProfile.phoneBusiness = data.phoneBusiness;
        memberShortProfile.phoneMobileBusiness = data.phoneMobileBusiness;
        memberShortProfile.emergencyContact = data.emergencyContact;
        memberShortProfile.emailBusiness = data.emailBusiness;
        memberShortProfile.salesListCredits = data.salesListCredits.data;
        memberShortProfile.memberClassifications = data.memberClassifications.data;
        memberShortProfile.memberFilterFlags = data.memberFilterFlags.data;
        memberShortProfile.memberHonors = data.memberHonors.data;

        memberShortProfile.offeringBookings = data.offeringBookings;

        memberShortProfile.paymentInformation = null;

        if (data.dogRelations.data) {
            memberShortProfile.dogRelations = data.dogRelations.data.map((relation) => DogMemberRelation.fromData(relation));
        }

        if (data.paymentInformation) {
            memberShortProfile.paymentInformation = {
                openAmount: data.paymentInformation.data.openAmount,
                paymentMethod: data.paymentInformation.data.paymentMethod,
                iban: data.paymentInformation.data.iban,
                linkToInvoices: data.paymentInformation.data.linkToInvoices
            };
        }

        Object.seal(memberShortProfile);
        return memberShortProfile;
    }

    static relationsFromData(relations) {
        const parentChildRelations = relations.parentChildRelations.map(relation => {
            return {
                child: MemberShortProfileMember.fromData(relation.child),
                parent: MemberShortProfileMember.fromData(relation.parent),
            };
        });
        const siblingRelations = relations.siblingRelations.map(relation => {
            return {
                member: MemberShortProfileMember.fromData(relation.member),
            };
        });
        const spouseRelations = relations.spouseRelations.map(relation => {
            return {
                member: MemberShortProfileMember.fromData(relation.member),
            };
        });
        const familyRelations = relations.familyRelations.map(relation => {
            return {
                member: MemberShortProfileMember.fromData(relation.member),
            };
        });

        return {
            parentChildRelations,
            siblingRelations,
            spouseRelations,
            familyRelations,
        };
    }
}

export class MemberShortProfileMember {
    fullName() {
        let fullName = this.lastName;

        if (this.firstName) {
            fullName = this.firstName + ' ' + fullName;
        }

        if (this.academicTitle) {
            fullName = this.academicTitle.value + ' ' + fullName;
        }

        return fullName;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let member = new MemberShortProfileMember();
        member.id = data.id;

        member.academicTitle = null;
        if (data.academicTitle && data.academicTitle.data) {
            member.academicTitle = ParameterValue.fromData(data.academicTitle.data);
        }

        member.firstName = data.firstName;
        member.lastName = data.lastName;
        member.gender = data.gender;
        member.street = data.street;
        member.careOf = data.careOf;
        member.zip = data.zip;
        member.city = data.city;
        member.hasAvatar = data.hasAvatar;
        member.avatarFileName = data.avatarFileName;
        member.contractState = new MemberContractState(data.contractState.status, data.contractState.contractType);
        member.membershipNumber = data.membershipNumber;
        member.dateOfBirth = data.dateOfBirth;
        member.isDunningActive = data.isDunningActive;

        Object.seal(member);
        return member;
    }
}
